module.exports = __webpack_public_path__ + "img/neon_pauc.14ecb02.png";